import styled from 'styled-components';
import { Row } from 'react-flexbox-grid';

interface IAddFilterStyle {
  iconOnly?: boolean;
  inMaster?: boolean;
}

interface IFilterProfileContainer {
  inMaster?: boolean;
}

export const FilterProfileContainer = styled.div`
  position: relative;
  height: ${(props: IFilterProfileContainer) => (props.inMaster ? 'auto' : '380px')};
  margin: ${(props: IFilterProfileContainer) => (props.inMaster ? '5px' : '0')};
`;

export const AddFilterStyle = styled.div`
  position: absolute;
  top: ${(props: IAddFilterStyle) => (props.inMaster ? '-60px' : props.iconOnly ? '-44px' : '-55px')};
  right: ${(props: IAddFilterStyle) => (props.iconOnly ? '0px' : '-10px')};
`;

export const FilterHeader = styled(Row)`
  padding: 10px;
  background-color: #f3f3f3;
  margin-bottom: 10px;
`;

export const FilterBody = styled.div`
  overflow-x: hidden;
  padding-top: 10px;
`;

interface ICustomTimeSelectBody {
  onTable?: boolean;
}

export const CustomTimeSelectBody = styled.div`
  display: flex;
  flex-direction: ${(props: ICustomTimeSelectBody) => (props.onTable ? 'row' : 'column')};
`;

export const SwitchFieldBodyTimeSelect = styled.div`
  display: flex;
  position: absolute;
  top: 3px;
  & .label-custom-time-select {
    margin: 9px 0 0 0;
    font-size: 10px;
  }
  & .gsi-form-field-container .bp3-control-indicator {
    height: 0.7em !important;
  }
  & .gsi-form-field-container .bp3-control-indicator::before {
    height: calc(1em - 10px) !important;
    width: calc(1em - 10px) !important;
  }

  & .gsi-form-field-container input:checked ~ .bp3-control-indicator::before {
    left: calc(100% - 0.7em) !important;
  }
`;
